// src/components/layout/Header.jsx
import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faShoppingCart, faBars, faTimes, faUser } from '@fortawesome/free-solid-svg-icons';

import { useAuth } from '../../hooks/useAuth';
import { useCart } from '../../contexts/CartContext';

import logo from '../../assets/logo/ink.png';

const Header = () => {
  const { currentUser, isAdmin, logout } = useAuth();
  const { cart } = useCart();

  const [menuOpen, setMenuOpen] = useState(false);

  const cartCount = cart.reduce((sum, item) => sum + item.quantity, 0);

  const handleLogout = async () => {
    await logout();
    setMenuOpen(false);
  };

  return (
    <header className="site-header">
      <div className="header-container">
        {/* ☰ Hamburger */}
        <button
          className="hamburger-btn"
          onClick={() => setMenuOpen(!menuOpen)}
          aria-label="Toggle menu"
        >
          <FontAwesomeIcon icon={menuOpen ? faTimes : faBars} />
        </button>

        {/* Logo */}
        <Link to="/" className="header-logo-link">
          <img src={logo} alt="DKL Books Logo" className="header-logo-image" />
        </Link>

        {/* Navigation */}
        <nav className={`header-nav ${menuOpen ? 'open' : ''}`}>
          <Link to="/shop" className="nav-link" onClick={() => setMenuOpen(false)}>Shop</Link>
          <Link to="/about" className="nav-link" onClick={() => setMenuOpen(false)}>About</Link>
          <Link to="/contact" className="nav-link" onClick={() => setMenuOpen(false)}>Contact</Link>

          <Link to="/cart" className="cart-link" onClick={() => setMenuOpen(false)}>
            <FontAwesomeIcon icon={faShoppingCart} />
            {cartCount > 0 && <span className="cart-badge">{cartCount}</span>}
          </Link>

          <div className="auth-links">
            {currentUser ? (
              <>
                {isAdmin && (
                  <Link
                    to="/admin"
                    className="admin-dashboard-btn"
                    onClick={() => setMenuOpen(false)}
                  >
                    Admin Dashboard
                  </Link>
                )}

                {/* User Icon with Name */}
                <Link
                  to="/profile"
                  className="profile-icon-link"
                  onClick={() => setMenuOpen(false)}
                >
                  <div className="profile-icon-wrapper">
                    <FontAwesomeIcon icon={faUser} className="profile-icon" />
                    <span className="profile-name">
                      {currentUser.displayName || currentUser.email.split('@')[0]}
                    </span>
                  </div>
                </Link>

                <button onClick={handleLogout} className="logout-btn">
                  Logout
                </button>
              </>
            ) : (
              <Link
                to="/auth/login"
                className="nav-link login-link"
                onClick={() => setMenuOpen(false)}
              >
                Login
              </Link>
            )}
          </div>
        </nav>
      </div>
    </header>
  );
};

export default Header;
